































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { PropType } from "vue";
import { Server } from "@/store/server";
import { getModule } from "vuex-module-decorators";
import { Meta } from "@/store/meta";

export interface EditContents {
  name: string;
  description: string;
  icon: File | undefined;
  url: string | undefined;
  published: boolean;
}

@Component
export default class EditModal extends Vue {
  @Prop({
    required: true,
    type: Object as PropType<EditContents>,
    default: () =>
      ({
        name: "",
        description: "",
        icon: undefined,
        url: undefined,
        published: false,
      } as EditContents),
  })
  private editContents?: EditContents;

  @Prop({
    required: true,
    type: String,
    default: "service", // service or channel
  })
  private editType?: string;

  @Prop({
    required: false,
    type: String,
    default: "編集画面",
  })
  private editTitle?: string;

  isClick = false

  get server() {
    return getModule(Server);
  }

  get title() {
    if (this.editTitle) {
      return this.editTitle
    } else {
      return ""
    }
  }

  get targetType() {
    return this.editType ? this.editType : ""
  }

  sendContents = {
    name: "",
    description: "",
    icon: undefined,
    url: undefined,
    published: false,
  } as EditContents;

  isUploaded = false;
  previewImage = "";
  dropFile = new File([""], "", { type: "image/jpeg,image/png" });
  inputImageBinary = "" as string;
  limitFileSize = 256 * 1024; // 256 kb
  limitFileValidation = false;

  publishSetting = ["公開", "非公開"];

  //pre check
  isEditMode = true;
  get requiredText() {
    if (this.isEditMode) {
      return "（必須）";
    } else {
      return "";
    }
  }

  mounted() {
    // eslint-disable-next-line
    this.sendContents = this.editContents!;
  }

  get typeName() {
    switch (this.editType) {
        case "channel":
            return "チャンネル"
        case "service":
            return "サービス"
        case "user":
            return "配信ユーザ"
        case "vui":
            return "音声コマンド"
        default:
            return "Unknown"
    }
  }

  get currentPlan() {
    return getModule(Meta).plan
  }

  async inputImage(file: File) {
    //file size validation
    if (file.size > this.limitFileSize) {
      this.limitFileValidation = true;
      return;
    } else {
      this.limitFileValidation = false;
    }
    this.isUploaded = true;
    this.previewImage = window.URL.createObjectURL(file);

    //convert image to binary string
    // this.sendContents.icon = String(await this.readFileAsync(file)).replace(/data:.*\/.*;base64,/, '')
    this.sendContents.icon = file;
  }

  readFileAsync(file: File) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        resolve(reader.result);
      };
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  }

  checkButton() {
    //validation
    const validTypeName = (
      this.$refs.typeName as Vue & { checkHtml5Validity: () => boolean }
    ).checkHtml5Validity();

    if (this.editType != 'user') {
        const validTypeDescription = (
          this.$refs.typeDescription as Vue & { checkHtml5Validity: () => boolean }
        ).checkHtml5Validity();
        if (!(validTypeName && validTypeDescription)) {
          return;
        }
        if (this.editType == "service" && this.currentPlan != 'broadcaster') {
          const validServiceUrl = (
            this.$refs.serviceUrl as Vue & { checkHtml5Validity: () => boolean }
          ).checkHtml5Validity();
          if (!validServiceUrl) {
            return;
          }
        }
    }

    this.isEditMode = false;
  }

  sendButton() {
    if (this.isClick) {
      return
    }

    this.isClick = true

    if (!this.isUploaded) {
      this.sendContents.icon = undefined
    }
    this.$emit("clickYes", this.sendContents);
  }
}
